'use strict';let

SortExtensions=class SortExtensions{
constructor(sortFn){
this._sortFn=sortFn;
}

invert(){
return item=>-1*this._sortFn(item);
}

static extend(sortFn){
return new SortExtensions(sortFn);
}};


module.exports=SortExtensions.extend;
//# sourceMappingURL=sortExtensions.js.map
